import { Button } from 'antd';
import classNames from 'classnames';
import _ from 'lodash';
import './index.scss';

export default (props) => {
  const {
    variant,
    className,
    rounded = false,
    fullWidth = true,
    children,
    disabled,
  } = props;

  const inheritedProps = _.pick(props, [
    'htmlType',
    'onClick',
    'type',
    'href',
    'icon',
    'target',
    'loading',
    'style',
  ]);

  return (
    <Button
      {...inheritedProps}
      className={classNames('zorba-button', {
        [className]: className,
        [variant]: variant,
        'btn-rounded': rounded,
        'full-width': fullWidth,
      })}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
